"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundServerFunctionList = exports.backgroundLocalFunctionList = exports.batchBackgroundServerFunctionList = void 0;
__exportStar(require("./components/CheckAudioClippingLocal"), exports);
__exportStar(require("./components/SegmentAudioLocal"), exports);
__exportStar(require("./components/ArrayFilterLocal"), exports);
__exportStar(require("./components/BgAPIUserLocationComponent"), exports);
__exportStar(require("./components/NullCheckLocal"), exports);
__exportStar(require("./components/BgLocalArrayPushComponent"), exports);
__exportStar(require("./components/BgLocalCopyComponent"), exports);
__exportStar(require("./components/BgLocalCheckEligibilityComponent"), exports);
__exportStar(require("./components/BgLocalCheckInRangeComponent"), exports);
__exportStar(require("./components/BgLocalFetchDistrictNamesComponent"), exports);
__exportStar(require("./components/BgLocalIncrementIntComponent"), exports);
__exportStar(require("./components/CreateDegradedStrCopy"), exports);
__exportStar(require("./components/LanguageMismatch"), exports);
__exportStar(require("./components/AudioBgNoiseCheck"), exports);
// Batch background server function list for autotransform batch components
exports.batchBackgroundServerFunctionList = {
    TO_UPPER: 'To Upper Case (Batch)',
    ACS: 'Azure Cognitive Services Transcription',
    SEGMENTED_TRANSCRIPTION: 'Segmented Transcription',
    INDIC_CONFORMER_BATCH: 'Indic-Conformer Batch Transcription',
};
exports.backgroundLocalFunctionList = {
    CHECK_AUDIO_CLIPPING: 'Check Clipping',
    SEGMENT_AUDIO: 'Automatic audio segmentation',
    ARRAY_FILTER: 'Array Filtering',
    NULL_CHECK: 'Null Check',
    GET_USER_LOCATION: 'Get User Location',
    INCREMENT_INT: 'Increment Integer',
    FETCH_DISTRICT_NAMES: 'Fetch District Names',
    CHECK_IN_RANGE: 'Check Value in Range',
    CHECK_ELIGIBILITY: 'Check Eligibility',
    ARRAY_PUSH: 'Array Push',
    COPY: 'Copy',
};
// Background server function list for autotransform components
exports.backgroundServerFunctionList = {
    ACS: 'Azure Cognitive Services Transcription',
    APPLY_PAYMENT_CREDITS: 'Apply Payment Credits',
    ASR_EVALUATION: 'ASR Evaluation',
    ASR_VALIDATION: 'ASR Validation',
    AUDIO_BG_NOISE_CHECK: 'Check Audio Background Noise',
    AUDIO_DURATION_CHECK: 'Audio Duration Check',
    AUDIO_SHRED_ON_SILENCE: 'Audio Shred on Silence',
    BEG_SILENCE_TRIMMER: 'Trim Silence at Start',
    CALCULATE_SNR: 'Calculate SNR',
    CHECK_GENDER: 'Check the Gender',
    CHECK_SEGMENTS: 'Check Segments',
    CHECK_SPEECH_PRESENCE: 'Check Speech Presence',
    COMPARE: 'Compare',
    COMPUTE_PAYMENT: 'Compute Payment',
    COPY: 'Copy',
    CORR_VAL_QUALITY_METRICS: 'Correctness Validation Quality Metrics',
    CREATE_DEGRADED_STR_COPY: 'Create Degraded String Copy',
    CSC_PROFILE_VALIDATION: 'CSC Profile Validation',
    DETECT_INDIC_LANGUAGE: 'Detect Indic Language',
    DUAL_CHANNEL_TO_MONO: 'Dual Channel to Mono',
    END_SILENCE_TRIMMER: 'Trim Silence at End',
    FILE_SIZE_CHECK: 'File Size Check',
    FIX_LOW_VOLUME: 'Fix Low Volume',
    FIX_MANUAL_SEGMENTS: 'Fix Manual Segments',
    GENERATE_OVERLAP_PAIR_WORK_ITEMS: 'Generate Overlap Pair Work Items',
    GENERATE_TEXT_FEEDBACK: 'Generate Text Feedback',
    GET_CONFERENCER_FILES: 'Get Conferencer Files',
    IMAGE_MERGE: 'Image Merge',
    INDIC_CONFORMER_TRANSCRIPTION: 'Indic-Conformer Transcription',
    LANGUAGE_CORRECTION: 'Language Correction',
    LANGUAGE_MISMATCH: 'Language Mismatch',
    LLM_CALL: 'LLM Call',
    LONG_PAUSES_CHECK: 'Long Pauses Check',
    MERGE_DOMINANT_SHRED_SEGMENTS: 'Merge Dominant Shred Segments',
    MERGE_SHRED_SEGMENTS: 'Merge Shred Segments',
    NOISE_REDUCTION: 'Noise Reduction',
    PAYMENT_SPLIT: 'Payment Split',
    PINCODE_TO_LOCATION: 'Pincode to Location',
    PREDICT_GENDER: 'Predict Gender',
    PROFILE_VALIDATION: 'Profile Validation',
    QUALITY_METRICS: 'Quality Metrics',
    RESOLVE_OVERLAP_PAIR_WORKER_PACK: 'Resolve Overlap Pair Worker Pack',
    RE_SEGMENT_OVERLAPPED_SEGMENTS: 'Re-segment Overlapped Segments',
    SCRIPT_SEGMENTATION: 'Script Segmentation',
    SEGMENTS_SILENCE_CHECK: 'Segments Silence Check',
    SELECT_OVERLAP_DOMINANT_SPEAKER: 'Select Overlap Dominant Speaker',
    SLICE_AUDIO: 'Slice Audio',
    SLICE_AUDIO_BY_SOURCE_CHANNEL: 'Slice Audio by Source Channel',
    SLICE_OVERLAP_PAIR_WORKER_PACK: 'Slice Overlap Pair Worker Pack',
    SLICE_SHRED_SEGMENTS: 'Slice Shred Segments',
    SPEECH_DURATION_MEASUREMENT: 'Speech Duration Measurement',
    SPEECH_FLUENCY_CHECK: 'Speech Fluency Check',
    SPEECH_SIMILARITY: 'Speech Similarity',
    SPLIT_AUDIO_CHANNELS: 'Split Audio Channels',
    SWAHILI_TRANSCRIPTION: 'Swahili Transcription',
    TO_UPPER: 'To Upper Case',
    TRANSCRIPTION_VALIDATION_WITH_FEEDBACK: 'Transcription Validation with Feedback',
    TTS_AUDIO_MERGE: 'TTS Audio Merge',
    TTS_BATCH_ASR_QA: 'TTS Batch ASR QA',
    TTS_BATCH_AUTO_QA: 'TTS Batch Auto QA',
    TTS_FLAT_ASR_QA: 'TTS Flat ASR QA',
    TTS_FLAT_AUDIO_MERGE: 'TTS Flat Audio Merge',
    TTS_FLAT_AUTO_QA: 'TTS Flat Auto QA',
    TTS_FLAT_FUNNEL_ASR_QA: 'TTS Flat Funnel ASR QA',
    TTS_FLAT_FUNNEL_AUDIO_MERGE: 'TTS Flat Funnel Audio Merge',
    TTS_FLAT_FUNNEL_FINAL_GATE: 'TTS Flat Funnel Final Gate',
    TTS_FLAT_FUNNEL_SCRIPT_SEGMENTATION: 'TTS Flat Funnel Script Segmentation',
    TTS_FLAT_SCRIPT_SEGMENTATION: 'TTS Flat Script Segmentation',
    VAANI_KYC_VALIDATION: 'Vaani KYC Validation',
    VAANI_PROFILE_TASK_VALIDATION: 'Vaani Profile Task Validation',
    VAD: 'Voice Activity Detection',
    VALIDATION_SUMMARY: 'Validation Summary',
};
//# sourceMappingURL=Index.js.map